var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4D53792E-84BF-4EEB-9DA6-34C36BD7AD36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Sidebar-/-Inicio",
    transform: "translate(-22.000000, -99.000000)",
    fill: "#B4B4B4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(22.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5000576,0 L2.49998926,0 C1.12200219,0 0,1.3323724 0,2.96878131 L0,16.0312744 C0,17.6676276 1.12200219,19 2.49998926,19 L21.5000107,19 C22.8779978,19 24,17.6676276 24,16.0312744 L24,2.96878131 C24.0000469,1.3323724 22.8780447,0 21.5000576,0 Z M23.0000605,16.0312187 C23.0000605,17.0132978 22.3270749,17.8124652 21.5000576,17.8124652 L2.49998926,17.8124652 C1.67297202,17.8124652 0.999986328,17.0132978 0.999986328,16.0312187 L0.999986328,2.96878131 C0.999986328,1.98670217 1.67297202,1.18753479 2.49998926,1.18753479 L21.5000107,1.18753479 C22.327028,1.18753479 23.0000137,1.98670217 23.0000137,2.96878131 L23.0000137,16.0312187 L23.0000605,16.0312187 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4999385,4.22222222 L0.500014648,4.22222222 C0.224015187,4.22222222 0,4.45868131 0,4.75001237 L0,7.9166543 C0,8.20798535 0.224015187,8.44444444 0.500014648,8.44444444 L23.4999854,8.44444444 C23.7759848,8.44444444 24,8.20798535 24,7.9166543 L24,4.75001237 C23.9999531,4.45868131 23.7759379,4.22222222 23.4999385,4.22222222 Z M22.9999707,7.38886415 L0.999982422,7.38886415 L0.999982422,5.27775304 L22.9999707,5.27775304 L22.9999707,7.38886415 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1249927,10.5555556 L18.8750073,10.5555556 C17.8412338,10.5555556 17,11.2659307 17,12.1388951 L17,13.1944383 C17,14.0674026 17.8412338,14.7777778 18.8750073,14.7777778 L20.1249927,14.7777778 C21.1587662,14.7777778 22,14.0674026 22,13.1944383 L22,12.1388951 C22,11.2659802 21.1587662,10.5555556 20.1249927,10.5555556 Z M21,13.1944321 C21,13.4857631 20.6639792,13.7222222 20.2499824,13.7222222 L18.7500176,13.7222222 C18.3360208,13.7222222 18,13.4857631 18,13.1944321 L18,12.1389013 C18,11.8475702 18.3360208,11.6111111 18.7500176,11.6111111 L20.2499824,11.6111111 C20.6639792,11.6111111 21,11.8475702 21,12.1389013 L21,13.1944321 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.53171255fcdfc0ffe7b2f368fe971155.svg";
export { ForwardRef as ReactComponent };